'use strict';

require("core-js/modules/es6.object.assign");

var _require = require('./helpers'),
    isFunction = _require.isFunction,
    composeErrorMessage = _require.composeErrorMessage;

function interfaceObject(error) {
  for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }

  Object.assign.apply(Object, [error].concat(props));
  error.description = isFunction(error.message) ? error.message(error) : error.message;
  error.message = error.code ? composeErrorMessage(error.code, error.description) : error.description;
}

module.exports = interfaceObject;